import { ENROLLMENT_ROUTES, PROGRAM_ROUTES } from 'navigation/types/routes'
import { generatePath, Navigate, useMatch, useParams } from 'react-router-dom'

export const ProgramRedirects = () => {
  const { programId, workflowId } = useParams()
  const isEnrollmentRoot = useMatch(PROGRAM_ROUTES.ENROLL)

  if (!!programId && !!isEnrollmentRoot) {
    return <Navigate to={generatePath(PROGRAM_ROUTES.FIELDS_ELIGIBLE, { programId })} replace />
  }

  if (workflowId) {
    return <Navigate to={generatePath(ENROLLMENT_ROUTES.DETAIL, { workflowId })} replace />
  }

  return <Navigate to={PROGRAM_ROUTES.ROOT} replace />
}
